import _extends from "@babel/runtime-corejs3/helpers/extends";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import * as React from 'react';
import classNames from 'classnames';
import Context from '../../context';
import Calendar from '../../calendar';
import TimePanel from '../time/time';
function DatetimePanel(props) {
  var context = React.useContext(Context);
  var prefixCls = context.prefixCls,
    panelPosition = context.panelPosition,
    dateValue = context.dateValue,
    rangeValue = context.rangeValue;
  var disabledTimePanel = props.disabledTimePanel,
    showTime = props.showTime,
    dateHeader = props.dateHeader;
  var value = dateValue;
  if (panelPosition === 'left') {
    value = rangeValue[0];
  } else if (panelPosition === 'right') {
    value = rangeValue[1];
  }
  var timeProps = _typeof(showTime) === 'object' ? _extends({}, showTime) : {};
  var disabledTimes = disabledTimePanel ? disabledTimePanel(value || null) : {};
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-datetime-panel"), {
      // [`${panelPrefixCls}-active`]: activePanel,
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(prefixCls, "-date"))
  }, dateHeader, /*#__PURE__*/React.createElement(Calendar, _extends({}, props))), /*#__PURE__*/React.createElement(TimePanel, _extends({}, props, {
    format: undefined
  }, timeProps, disabledTimes, {
    defaultValue: undefined
  })));
}
export default DatetimePanel;